import { TableKeyEnum } from '@/hooks/useTableSettingsStore';
import { createTableFiltersState } from '@/utils/table-filters';

import { SupportFilters } from '../types';

export const useSupportsFilters = createTableFiltersState<SupportFilters>({
  tableKey: TableKeyEnum.SUPPORTS,
});
